import type { ScheduledDowngradeData } from '../../repositories/stripe-account-repo/schemas/scheduled-downgrade.zod';

export class ScheduledDowngrade {
  constructor(private readonly values: ScheduledDowngradeData) {}

  public getSubscriptionId() {
    return this.values.subscriptionId;
  }

  public getSubscriptionScheduleId() {
    return this.values.subscriptionScheduleId;
  }

  public getPlanName() {
    return this.values.planName;
  }

  public getScheduledDate(): Date {
    return new Date(this.values.scheduledDate * 1000);
  }
}
